// removed by extract-text-webpack-plugin
module.exports = {"container":"style__container___2X23x","title":"style__title___21Axt","subtitle":"style__subtitle___11z5v","inputContainer":"style__inputContainer___1DIqh","input":"style__input___1qiDZ","inputMessage":"style__inputMessage___3DAFH","inputPassword":"style__inputPassword___32JVT","inputError":"style__inputError___2RIsH","error":"style__error___IuvxS","button":"style__button___1ii8m","text":"style__text___2Xjl4","textBold":"style__textBold___3BVNF","backButton":"style__backButton___jldN4"};


//////////////////
// WEBPACK FOOTER
// ./src/pages/forgotpassword/style.css
// module id = 1031
// module chunks = 0